@if (showScrollButton()) {
  <button (click)="scrollToTop()" class="scroll-to-top">
    <outlaw-icon name="arrowTop" [size]="{ mobile: 16, desktop: 24 }" />
  </button>
}
